import React from 'react';
import PermissionGate from '../CadastroPerfilUsuario/PermissionGate';

function MateriaPrimaFormulario({ botao, eventoTeclado, cadastrarMateriaPrima, obj, alterarMateriaPrima, fornecedores, ativar, inativar, remover }) {
  return (
    <form>
      <div className="modal-form-field">
        <input
          type="text"
          value={obj.descricao ?? ''}
          onChange={eventoTeclado}
          name='descricao'
          placeholder="Descrição"
          className='form-control'
        />
      </div>

      <div className="modal-form-field">
        <input
          type="text"
          value={obj.cor ?? ''}
          onChange={eventoTeclado}
          name='cor'
          placeholder="Cor"
          className='form-control'
        />
      </div>

      <div className="modal-form-field">
        <input
          type="number"
          value={obj.custo ?? ''}
          onChange={eventoTeclado}
          name='custo'
          placeholder="Custo"
          className='form-control'
        />
      </div>

      <div className="modal-form-field">
        <input
          type="text"
          value={obj.codigoMateria ?? ''}
          onChange={eventoTeclado}
          name='codigoMateria'
          placeholder="Código da Matéria"
          className='form-control'
        />
      </div>

      <div className="modal-form-field">
        <select
          value={obj.idFornecedor ?? ''}
          onChange={eventoTeclado}
          name='idFornecedor'
          className='form-control'
        >
          <option value="">Selecione um fornecedor</option>
          {fornecedores.map((fornecedor) => (
            <option key={fornecedor.id} value={fornecedor.id}>
              {fornecedor.nomeEmpresa}
            </option>
          ))}
        </select>
      </div>


      <div className="modal-form-field">
        <input
          type="text"
          value={obj.umSigla ?? ''}
          onChange={eventoTeclado}
          name='umSigla'
          placeholder="Unidade de Medida"
          className='form-control'
        />
      </div>

      <div className="modal-form-field">
        <input
          type="number"
          value={obj.saldoEstoque ?? ''}
          onChange={eventoTeclado}
          name='saldoEstoque'
          placeholder="Saldo em Estoque"
          className='form-control'
        />
      </div>

      <div className="modal-buttons">
        {botao ? (
          <div className="modal-actions">
            <PermissionGate permissions={["materiaPrimaCadastrar"]}>
              <button type="button" onClick={cadastrarMateriaPrima} className='modal-button modal-button-primary'>
                Cadastrar
              </button>
            </PermissionGate>
          </div>
        ) : (
          <div className="modal-actions">
            <PermissionGate permissions={["materiaPrimaAlterar"]}>
              <button type="button" onClick={alterarMateriaPrima} className='modal-button modal-button-warning'>
                Alterar
              </button>
            </PermissionGate>

            <PermissionGate permissions={["materiaPrimaRemover"]}>
              <button type="button" onClick={remover} className='modal-button modal-button-danger'>
                Remover
              </button>
            </PermissionGate>

            <PermissionGate permissions={["materiaPrimaAtivar"]}>
              <button type="button" onClick={ativar} className='modal-button modal-button-secondary'>
                Ativar
              </button>
            </PermissionGate>

            <PermissionGate permissions={["materiaPrimaInativar"]}>
              <button type="button" onClick={inativar} className='modal-button modal-button-secondary'>
                Inativar
              </button>
            </PermissionGate>
          </div>
        )}
      </div>
    </form>
  );
}

export default MateriaPrimaFormulario;
